import React, { useState, useRef, useEffect } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { getCustomerName, removeCustomerId } from "utility/HeaderConfig";
import { Link, useNavigate } from "react-router-dom";
import { useCartContext } from "context/UseCartContext";
import toast, { Toaster } from "react-hot-toast";
import OpenModal from "components/OpenModal";

export default function TopbarMenus({ lang = "en", t = (k) => k }) {
  const history = useNavigate();
  const { login, dispatch } = useCartContext();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const logout = () => {
    removeCustomerId();
    dispatch({ type: "LOGIN", payload: null });
    dispatch({ type: "ADD", payload: null });
    const customerKeys = [
      "CartList", "customerData", "customerId", "customerName",
      "cusAddress", "mail", "statusId", "paymentStatus", "invoiceid",
      "invId", "twalletInvcId", "payId", "estimationId", "corporateId", "isChecked"
    ];
    customerKeys.forEach((key) => reactLocalStorage.remove(key));
    setOpen(false);
    toast.success(t("Signed out"), {
      duration: 1500, position: "top-right",
      style: { background: "#1a1a1a", color: "#fff", borderRadius: "10px", fontSize: "13px" },
    });
    setTimeout(() => history("/"), 1200);
  };

  const openModal = (type) => {
    setOpen(false);
    setTimeout(() => dispatch({ type: "MODAL", payload: type }), 80);
  };

  return (
    <div className="pmr-topbar-menus">
      <Toaster position="top-right" />

      {/* Links — hidden on mobile */}
      <Link to="/Offers" className="pmr-topnav-link">{t("Offers")}</Link>
      <Link to="/BookAnAppointment" className="pmr-topnav-link">{t("Booking Appointment")}</Link>

      {/* Account — CLICK toggle */}
      <div className="pmr-acct-wrap" ref={wrapRef}>
        <button
          className="pmr-acct-btn"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-haspopup="true"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          <span className="pmr-acct-label">
            {login ? (getCustomerName()?.split(" ")[0] || t("Account")) : t("Account")}
          </span>
          <svg
            width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
            style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}
          >
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>

        <div className={`pmr-acct-panel${open ? " pmr-acct-panel--visible" : " pmr-acct-panel--hidden"}`}>
          {login ? (
            <>
              <div className="pmr-acct-name">{getCustomerName()}</div>
              <div className="pmr-acct-divider" />
              {[
                // {
                //   label: t("My Scheme"),
                //   action: () => {
                //     setOpen(false);
                //     if (getCustomerId()) history("/MyScheme");
                //     else history("/LoginPage");
                //   },
                // },
                { label: t("My Wishlist"), to: "/WishList" },
                { label: t("My Purchase"), to: "/MyPurchase" },
                { label: t("My Address"), to: "/AddAddress" },
              ].map((item, i) =>
                item.to ? (
                  <Link key={i} to={item.to} className="pmr-acct-item" onClick={() => setOpen(false)}>{item.label}</Link>
                ) : (
                  <button key={i} onClick={item.action} className="pmr-acct-item">{item.label}</button>
                )
              )}
              <div className="pmr-acct-divider" />
              <button onClick={logout} className="pmr-acct-item pmr-acct-item--danger">{t("Sign Out")}</button>
            </>
          ) : (
            <>
              <p className="pmr-acct-greeting">{t("Welcome to PMR Venkateswara Jewellery")}</p>
              <div className="pmr-acct-divider" />
              <button className="pmr-acct-signin" onClick={() => openModal("login")}>{t("Sign In")}</button>
              <button className="pmr-acct-item" onClick={() => openModal("register")}>{t("Create Account")}</button>
            </>
          )}
        </div>
      </div>

      <OpenModal />
    </div>
  );
}